<template>
  <div :style="'background-color:'+data.style.backgroundColor" class="windows ">
     <div v-for="(item,index) in data.data" :key="index" :class="data.style.class" >
        <img class="width100" :src="item.imgUrl || require('@/assets/images/normal.png')" alt="">
     </div>
  </div>
</template>
<script>
export default {
   props: { data: Object },
  name:"windows"
}
</script>

<style lang="less" scoped>
.windows{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .full{
    width: 100%;
  }
  .half{
    width: 50%;
  }
  .third{
    width: 33%;
  }
  .quarter{
    width: 25%;
  }
}
</style>